export const UPDATE_DASHBOARD_EVENTS_COUNT =
  "dashboardRecentActivityEvents/UPDATE_DASHBOARD_EVENTS_COUNT";
export const UPDATE_EVENT_RELATED_INVESTMENTS =
  "dashboardRecentActivityEvents/UPDATE_EVENT_INVESTMENTS";
export const CLEAN_DASHBOARD_EVENTS =
  "dashboardRecentActivityEvents/CLEAN_DASHBOARD_EVENTS";
